import { render } from "./OurUpcomingEvents.vue?vue&type=template&id=4a219e70"
import script from "./OurUpcomingEvents.vue?vue&type=script&lang=js"
export * from "./OurUpcomingEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__